import { render } from "./PrivacyPolicyContent.vue?vue&type=template&id=39965aa6&scoped=true"
const script = {}

import "./PrivacyPolicyContent.vue?vue&type=style&index=0&id=39965aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39965aa6"]])

export default __exports__